import { render, staticRenderFns } from "./SliceListVisuals.vue?vue&type=template&id=4093e4d6&scoped=true"
import script from "./SliceListVisuals.vue?vue&type=script&lang=js"
export * from "./SliceListVisuals.vue?vue&type=script&lang=js"
import style0 from "./SliceListVisuals.vue?vue&type=style&index=0&id=4093e4d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4093e4d6",
  null
  
)

export default component.exports